import React from 'react';
import { FlightInfo } from './types';
import { Plane } from 'lucide-react';
import Image from '@/lib/app-image';
import { getAirlineIconUrl } from '@/lib/airlineIcon';
import { useSelector } from 'react-redux';

function BaggageRules({ data }: { data: FlightInfo }) {
  const flightSearchInput = useSelector((state: any) => state.flightSearch);
  return (
    <div className="w-full">
      {/* Airline Info Section */}
      <div className="flex w-full flex-row items-center p-2 sm:p-4">
        <Image
          alt="airline_logos"
          src={getAirlineIconUrl(data?.airline_code || 'none')}
          className="h-6 w-6 flex-shrink-0 sm:h-8 sm:w-8"
          crossOrigin="anonymous"
        />
        <div className="ml-2 min-w-0 flex-1">
          <h4 className="truncate text-[10px] font-semibold text-text_secondary sm:text-sm">
            {data?.origin} - {data?.destination}
          </h4>
          <h4 className="truncate text-[10px] font-semibold text-text_secondary sm:text-sm">
            {data?.airline_name}, {data?.flight_number}
          </h4>
        </div>
      </div>

      {/* Baggage Rules Table - Mobile Responsive */}
      <div className="border-light w-full overflow-hidden rounded-2xl border-2">
        {/* Header Row */}
        <div className="flex w-full flex-row bg-gray-100">
          <h4 className="border-light w-1/3 border-r p-2 text-center text-[10px] font-semibold text-text_secondary sm:p-4 sm:text-sm">
            Baggage Summary
          </h4>
          <h4 className="border-light w-1/3 border-r p-2 text-center text-[10px] font-semibold text-text_secondary sm:p-4 sm:text-sm">
            Check In
          </h4>
          <h4 className="w-1/3 p-2 text-center text-[10px] font-semibold text-text_secondary sm:p-4 sm:text-sm">
            Hand Baggage
          </h4>
        </div>

        {/* Content Row */}
        <div className="flex w-full flex-row">
          <h4 className="border-light w-1/3 border-r p-2 text-center text-[10px] font-semibold text-text_secondary sm:p-4 sm:text-sm">
            Details
          </h4>
          <h4 className="border-light w-1/3 border-r p-2 text-center text-[10px] font-semibold text-text_secondary sm:p-4 sm:text-sm">
            {data?.checkin_baggage}
          </h4>
          <h4 className="w-1/3 p-2 text-center text-[10px] font-semibold text-text_secondary sm:p-4 sm:text-sm">
            {data?.hand_baggage}
          </h4>
        </div>
      </div>
    </div>
  );
}

export default BaggageRules;
